import dayjs, { Dayjs } from 'dayjs';
import { NewSiteAvailabilityEntry } from 'pages/Availability/common/FormDrawer/types';
import { BaseSiteAvailabilityEntry } from 'pages/Availability/types';

export interface ValidatePreviewResult {
  isValid: boolean;
  parsedEntry: BaseSiteAvailabilityEntry[]; // empty array when not valid
}

const getValidDateTime = (date: Dayjs | null) => {
  if (!date) {
    return null;
  }

  if (date?.isValid?.()) {
    return date;
  }
};

export function validatePreview(
  values: NewSiteAvailabilityEntry,
  siteSourceKey: string,
): ValidatePreviewResult {
  const validStartDateTime = getValidDateTime(dayjs(values.start));
  const validEndDateTime = getValidDateTime(dayjs(values.end));
  const startBeforeEnd =
    validStartDateTime &&
    validEndDateTime &&
    validStartDateTime.isBefore(validEndDateTime);
  const isValidOpenEnded = values.isOpenEnded && validStartDateTime;
  const allPositiveLimits =
    +(values.maxExportPower ?? 0) >= 0 &&
    +(values.maxImportPower ?? 0) >= 0 &&
    +(values.energyCapacity ?? 0) >= 0;
  // valid start always required; end may be null when open-ended
  const hasValidStart = Boolean(validStartDateTime);
  const isValid = Boolean(
    hasValidStart && allPositiveLimits && (startBeforeEnd || isValidOpenEnded),
  );

  if (isValid) {
    return {
      isValid: true,
      parsedEntry: [
        {
          id: -1,
          start: validStartDateTime!.toISOString(),
          end: validEndDateTime?.toISOString() ?? null,
          siteSourceKey,
          maxExportPower:
            values.maxExportPower !== null ? +values.maxExportPower : null,
          maxImportPower:
            values.maxImportPower !== null ? +values.maxImportPower : null,
          energyCapacity:
            values.energyCapacity !== null ? +values.energyCapacity : null,
          availabilityReason: values.availabilityReason,
          notes: values.notes,
          isOpenEnded: values.isOpenEnded,
          createdAt: new Date(Date.now()).toISOString(),
        },
      ],
    };
  }

  return { isValid: false, parsedEntry: [] };
}
